import {EventEmitter, Injectable} from '@angular/core';
import {IPlatformToolHandler} from '@shared/components/platform-tool/platform-tool-container/platform-tool-component';
import {InvalidateSubject} from '@shared/helpers/invalidate.subject';
import {MagicLinkModel, TabModel} from '@shared/models/platform-tool-models';
import {PlatformCommand} from '@shared/commands/command-base';
import {Router} from '@angular/router';

@Injectable({
  providedIn: 'root'
})

export class SelectTreatyCountryPairHandler implements IPlatformToolHandler {
  invalidateSubject: InvalidateSubject;
  magicLinkModel: MagicLinkModel;
  magicLinkModelValueChanged: EventEmitter<any>;

  constructor(
    private router: Router
  ) {
  }

  destroy(): void {
  }

  executeCommand(command: PlatformCommand) {
    if (command.fieldValues['RedirectUrl']) {
      this.router.navigateByUrl(command.fieldValues['RedirectUrl']);
    } else {
      switch (command.name) {
        case 'GoToNextPageCommand':
          console.log('GoToNextPageCommand..........................');
          this.goToNextPage();
          break;
        default:
          break;
      }
    }
  }

  goToNextPage() {
    if (!this.magicLinkModel.fieldValues['countryOne'] || !this.magicLinkModel.fieldValues['countryTwo']) {
      return;
    }
    const countryOne = this.magicLinkModel.fieldValues['countryOne'];
    const countryTwo = this.magicLinkModel.fieldValues['countryTwo'];
    this.router.navigateByUrl(`treaties/${countryOne.toLowerCase()}/${countryTwo.toLowerCase()}`);
  }

  setSelectedTab(selectedTab: TabModel): void {
  }

  valueChanged($event) {
  }

}
